import { render, staticRenderFns } from "./SetupCompanyConfirmTrial.vue?vue&type=template&id=1eec74d8&scoped=true"
import script from "./SetupCompanyConfirmTrial.vue?vue&type=script&lang=js"
export * from "./SetupCompanyConfirmTrial.vue?vue&type=script&lang=js"
import style0 from "./SetupCompanyConfirmTrial.vue?vue&type=style&index=0&id=1eec74d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eec74d8",
  null
  
)

export default component.exports